import { styled } from "styled-components";

export const FormContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const FormHeading = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  text-transform: uppercase;
`;
export const FormText = styled.p`
  font-size: 16px;
  margin-bottom: 24px;
  line-height: 1.5;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const Input = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  padding: 12px;
  border: 1px solid ${(props) => (props.$hasError ? "#ff0000" : "#000")};
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? "#ff0000" : "#000")};
  }
`;

export const Select = styled.select<{ $hasError?: boolean }>`
  width: 100%;
  padding: 12px;
  border: 1px solid ${(props) => (props.$hasError ? "#ff0000" : "#000")};
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  &:focus {
    outline: none;
    border-color: ${(props) => (props.$hasError ? "#ff0000" : "#000")};
  }
`;

export const FormLink = styled.a`
  text-decoration: underline;
  font-weight: bold;
`;

export const FormDivider = styled.div`
  border-top: 1px solid #000000;
  margin: 32px 0;
`;

export const ErrorMessage = styled.span`
  color: #ff0000;
  font-size: 12px;
  line-height: 1.4;
`;

export const EyeIcon = ({ isVisible }: { isVisible: boolean }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {isVisible ? (
      // Eye open icon
      <path
        d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
        fill="currentColor"
      />
    ) : (
      // Eye closed icon
      <path
        d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
        fill="currentColor"
      />
    )}
  </svg>
);
